import React from "react";
import "../designcss/Whattwedocontent.css";

const WhatwedoWhatsapp = () => {
  return (
    <section className="whatwedo-section">
      <div className="whatwedo-container">
        <h1 className="whatwedo-title">
          WhatsApp Campaigns for E-Commerce Businesses
        </h1>

        <p className="whatwedo-desc">
          For e-commerce brands, WhatsApp is a game-changer. It enables
          real-time engagement, personalized communication, and higher response
          rates compared to traditional channels. Here’s how it helps:
        </p>

        <div className="cards-wrapper">
          <div className="info-card">
            <h3>Drive More Sales with Direct Customer Engagement</h3>
            <p>
              Connect with shoppers directly through personalized offers,
              product recommendations, and updates.
            </p>
          </div>

          <div className="info-card">
            <h3>Reduce Cart Abandonment with Real-Time Notifications</h3>
            <p>
              Send automated reminders, order confirmations, and payment alerts
              to recover abandoned carts.
            </p>
          </div>

          <div className="info-card">
            <h3>Enhance Customer Experience with Post-Purchase Support</h3>
            <p>
              From delivery updates to return assistance, WhatsApp ensures
              customers are informed at every stage. 
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhatwedoWhatsapp;
